export default {
    'Login.title':'欢迎来到Slides Orator',
    'Login.phoneText': '手机号登录',
    'Login.captcha':'登录/注册',
    'Login.getCode':'获取验证码',
    'Login.resCode':'重新发送', 
    'Login.captchaPlaceholder':'短信验证码',
    'Login.phonePlaceholder':'请输入你的手机号',
    'Login.phoneError':'手机号输入有误',
    'Login.codeError':'请输入6位验证码',
    'Login.succeeded':'登录成功',
    'Login.sentCodeSucceeded':'验证码发送成功',
  };

